import React from 'react';
import { FaFolder, FaLeaf } from 'react-icons/fa';
import { SEGMENT_TYPE } from '../../../../../../../constants/radar';
import {
  SelectorContainer,
  TypeButton,
  TypeIcon,
  TypeLabel,
  TypeDescription,
} from './styles';

const NodeTypeSelector = ({ selectedType, onTypeChange, disabled }) => {
  return (
    <SelectorContainer>
      <TypeButton
        type="button"
        selected={selectedType === SEGMENT_TYPE.INTERNAL}
        onClick={() => onTypeChange(SEGMENT_TYPE.INTERNAL)}
        disabled={disabled}
      >
        <TypeIcon selected={selectedType === SEGMENT_TYPE.INTERNAL}>
          <FaFolder />
        </TypeIcon>
        <TypeLabel selected={selectedType === SEGMENT_TYPE.INTERNAL}>Internal</TypeLabel>
        <TypeDescription>
          Can contain other nodes and has a custom color
        </TypeDescription>
      </TypeButton>
      <TypeButton
        type="button"
        selected={selectedType === SEGMENT_TYPE.LEAF}
        onClick={() => onTypeChange(SEGMENT_TYPE.LEAF)}
        disabled={disabled}
      >
        <TypeIcon selected={selectedType === SEGMENT_TYPE.LEAF}>
          <FaLeaf />
        </TypeIcon>
        <TypeLabel selected={selectedType === SEGMENT_TYPE.LEAF}>Leaf</TypeLabel>
        <TypeDescription>
          End node with approval stages and tags
        </TypeDescription>
      </TypeButton>
    </SelectorContainer>
  );
};

export default NodeTypeSelector;
